export const OPTIONS = [
  { hour: 0, minute: 0, text: '12:00 AM', value: '00:00:00' },
  { hour: 0, minute: 15, text: '12:15 AM', value: '00:15:00' },
  { hour: 0, minute: 30, text: '12:30 AM', value: '00:30:00' },
  { hour: 0, minute: 45, text: '12:45 AM', value: '00:45:00' },
  { hour: 1, minute: 0, text: '1:00 AM', value: '01:00:00' },
  { hour: 1, minute: 15, text: '1:15 AM', value: '01:15:00' },
  { hour: 1, minute: 30, text: '1:30 AM', value: '01:30:00' },
  { hour: 1, minute: 45, text: '1:45 AM', value: '01:45:00' },
  { hour: 2, minute: 0, text: '2:00 AM', value: '02:00:00' },
  { hour: 2, minute: 15, text: '2:15 AM', value: '02:15:00' },
  { hour: 2, minute: 30, text: '2:30 AM', value: '02:30:00' },
  { hour: 2, minute: 45, text: '2:45 AM', value: '02:45:00' },
  { hour: 3, minute: 0, text: '3:00 AM', value: '03:00:00' },
  { hour: 3, minute: 15, text: '3:15 AM', value: '03:15:00' },
  { hour: 3, minute: 30, text: '3:30 AM', value: '03:30:00' },
  { hour: 3, minute: 45, text: '3:45 AM', value: '03:45:00' },
  { hour: 4, minute: 0, text: '4:00 AM', value: '04:00:00' },
  { hour: 4, minute: 15, text: '4:15 AM', value: '04:15:00' },
  { hour: 4, minute: 30, text: '4:30 AM', value: '04:30:00' },
  { hour: 4, minute: 45, text: '4:45 AM', value: '04:45:00' },
  { hour: 5, minute: 0, text: '5:00 AM', value: '05:00:00' },
  { hour: 5, minute: 15, text: '5:15 AM', value: '05:15:00' },
  { hour: 5, minute: 30, text: '5:30 AM', value: '05:30:00' },
  { hour: 5, minute: 45, text: '5:45 AM', value: '05:45:00' },
  { hour: 6, minute: 0, text: '6:00 AM', value: '06:00:00' },
  { hour: 6, minute: 15, text: '6:15 AM', value: '06:15:00' },
  { hour: 6, minute: 30, text: '6:30 AM', value: '06:30:00' },
  { hour: 6, minute: 45, text: '6:45 AM', value: '06:45:00' },
  { hour: 7, minute: 0, text: '7:00 AM', value: '07:00:00' },
  { hour: 7, minute: 15, text: '7:15 AM', value: '07:15:00' },
  { hour: 7, minute: 30, text: '7:30 AM', value: '07:30:00' },
  { hour: 7, minute: 45, text: '7:45 AM', value: '07:45:00' },
  { hour: 8, minute: 0, text: '8:00 AM', value: '08:00:00' },
  { hour: 8, minute: 15, text: '8:15 AM', value: '08:15:00' },
  { hour: 8, minute: 30, text: '8:30 AM', value: '08:30:00' },
  { hour: 8, minute: 45, text: '8:45 AM', value: '08:45:00' },
  { hour: 9, minute: 0, text: '9:00 AM', value: '09:00:00' },
  { hour: 9, minute: 15, text: '9:15 AM', value: '09:15:00' },
  { hour: 9, minute: 30, text: '9:30 AM', value: '09:30:00' },
  { hour: 9, minute: 45, text: '9:45 AM', value: '09:45:00' },
  { hour: 10, minute: 0, text: '10:00 AM', value: '10:00:00' },
  { hour: 10, minute: 15, text: '10:15 AM', value: '10:15:00' },
  { hour: 10, minute: 30, text: '10:30 AM', value: '10:30:00' },
  { hour: 10, minute: 45, text: '10:45 AM', value: '10:45:00' },
  { hour: 11, minute: 0, text: '11:00 AM', value: '11:00:00' },
  { hour: 11, minute: 15, text: '11:15 AM', value: '11:15:00' },
  { hour: 11, minute: 30, text: '11:30 AM', value: '11:30:00' },
  { hour: 11, minute: 45, text: '11:45 AM', value: '11:45:00' },
  { hour: 12, minute: 0, text: '12:00 PM', value: '12:00:00' },
  { hour: 12, minute: 15, text: '12:15 PM', value: '12:15:00' },
  { hour: 12, minute: 30, text: '12:30 PM', value: '12:30:00' },
  { hour: 12, minute: 45, text: '12:45 PM', value: '12:45:00' },
  { hour: 13, minute: 0, text: '1:00 PM', value: '13:00:00' },
  { hour: 13, minute: 15, text: '1:15 PM', value: '13:15:00' },
  { hour: 13, minute: 30, text: '1:30 PM', value: '13:30:00' },
  { hour: 13, minute: 45, text: '1:45 PM', value: '13:45:00' },
  { hour: 14, minute: 0, text: '2:00 PM', value: '14:00:00' },
  { hour: 14, minute: 15, text: '2:15 PM', value: '14:15:00' },
  { hour: 14, minute: 30, text: '2:30 PM', value: '14:30:00' },
  { hour: 14, minute: 45, text: '2:45 PM', value: '14:45:00' },
  { hour: 15, minute: 0, text: '3:00 PM', value: '15:00:00' },
  { hour: 15, minute: 15, text: '3:15 PM', value: '15:15:00' },
  { hour: 15, minute: 30, text: '3:30 PM', value: '15:30:00' },
  { hour: 15, minute: 45, text: '3:45 PM', value: '15:45:00' },
  { hour: 16, minute: 0, text: '4:00 PM', value: '16:00:00' },
  { hour: 16, minute: 15, text: '4:15 PM', value: '16:15:00' },
  { hour: 16, minute: 30, text: '4:30 PM', value: '16:30:00' },
  { hour: 16, minute: 45, text: '4:45 PM', value: '16:45:00' },
  { hour: 17, minute: 0, text: '5:00 PM', value: '17:00:00' },
  { hour: 17, minute: 15, text: '5:15 PM', value: '17:15:00' },
  { hour: 17, minute: 30, text: '5:30 PM', value: '17:30:00' },
  { hour: 17, minute: 45, text: '5:45 PM', value: '17:45:00' },
  { hour: 18, minute: 0, text: '6:00 PM', value: '18:00:00' },
  { hour: 18, minute: 15, text: '6:15 PM', value: '18:15:00' },
  { hour: 18, minute: 30, text: '6:30 PM', value: '18:30:00' },
  { hour: 18, minute: 45, text: '6:45 PM', value: '18:45:00' },
  { hour: 19, minute: 0, text: '7:00 PM', value: '19:00:00' },
  { hour: 19, minute: 15, text: '7:15 PM', value: '19:15:00' },
  { hour: 19, minute: 30, text: '7:30 PM', value: '19:30:00' },
  { hour: 19, minute: 45, text: '7:45 PM', value: '19:45:00' },
  { hour: 20, minute: 0, text: '8:00 PM', value: '20:00:00' },
  { hour: 20, minute: 15, text: '8:15 PM', value: '20:15:00' },
  { hour: 20, minute: 30, text: '8:30 PM', value: '20:30:00' },
  { hour: 20, minute: 45, text: '8:45 PM', value: '20:45:00' },
  { hour: 21, minute: 0, text: '9:00 PM', value: '21:00:00' },
  { hour: 21, minute: 15, text: '9:15 PM', value: '21:15:00' },
  { hour: 21, minute: 30, text: '9:30 PM', value: '21:30:00' },
  { hour: 21, minute: 45, text: '9:45 PM', value: '21:45:00' },
  { hour: 22, minute: 0, text: '10:00 PM', value: '22:00:00' },
  { hour: 22, minute: 15, text: '10:15 PM', value: '22:15:00' },
  { hour: 22, minute: 30, text: '10:30 PM', value: '22:30:00' },
  { hour: 22, minute: 45, text: '10:45 PM', value: '22:45:00' },
  { hour: 23, minute: 0, text: '11:00 PM', value: '23:00:00' },
  { hour: 23, minute: 15, text: '11:15 PM', value: '23:15:00' },
  { hour: 23, minute: 30, text: '11:30 PM', value: '23:30:00' },
  { hour: 23, minute: 45, text: '11:45 PM', value: '23:45:00' },
];
